import React from 'react';
import { Card } from '../../components/Card/Card';
import './Apps.css';

export const AppsModule: React.FC = () => {
  return (
    <div className="apps-module">
      <div className="apps-header">
        <div className="apps-header__content">
          <h1>My Apps</h1>
          <p>Manage and monitor your FancyCloud applications</p>
        </div>
      </div>

      <div className="apps-grid">
        <Card variant="bordered" className="app-card">
          <div className="app-card__header">
            <div className="app-icon">🔗</div>
          </div>
          <h3 className="app-name">FancyLink</h3>
          <p className="app-description">
            fancylinkd is a secure, low‑latency tunnel agent that connects your local
            services to FancyCloud with minimal setup and robust telemetry.
          </p>
          <div className="app-actions">
            <a 
              href="https://link.fancycloud.ca" 
              target="_blank" 
              rel="noopener noreferrer"
              className="app-link"
            >
              Open FancyLink →
            </a>
          </div>
        </Card>
      </div>
    </div>
  );
};
